module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    ref: "usuario",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.commit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    class: {
      'form-group': true
    }
  }, [_c('label', {
    attrs: {
      "for": "atributos"
    }
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('v-select', {
    ref: "inputCidade",
    attrs: {
      "options": _vm.listCidades,
      "name": "cidades"
    },
    model: {
      value: (_vm.cidadesSelecionadas),
      callback: function($$v) {
        _vm.cidadesSelecionadas = $$v
      },
      expression: "cidadesSelecionadas"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('nome')
    }
  }, [_c('label', {
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.name),
      expression: "dados.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nome')),
      expression: "errors.has('nome')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.email),
      expression: "dados.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('nivel')
    }
  }, [_c('label', {
    attrs: {
      "for": "nivel"
    }
  }, [_vm._v("Nível")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nivel),
      expression: "dados.nivel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nivel",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "nivel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "administrador"
    }
  }, [_vm._v("Administrador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "usuario"
    }
  }, [_vm._v("Usuário")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nivel')),
      expression: "errors.has('nivel')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('nivel')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('usuario')
    }
  }, [_c('label', {
    attrs: {
      "for": "usuario"
    }
  }, [_vm._v("Usuário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.usuario),
      expression: "dados.usuario"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "usuario",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "usuario", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('usuario')),
      expression: "errors.has('usuario')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('usuario')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('senha')
    }
  }, [_c('label', {
    attrs: {
      "for": "senha"
    }
  }, [_vm._v("Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.password),
      expression: "dados.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.atualizacao
      }),
      expression: "{required:!atualizacao}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "senha",
      "type": "password",
      "disabled": _vm.atualizacao
    },
    domProps: {
      "value": (_vm.dados.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('senha')),
      expression: "errors.has('senha')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('senha')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('confirmacaoSenha')
    }
  }, [_c('label', {
    attrs: {
      "for": "confirmacaoSenha"
    }
  }, [_vm._v("Redigite a Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmacaoSenha),
      expression: "confirmacaoSenha"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.atualizacao,
        is: _vm.dados.password
      }),
      expression: "{required:!atualizacao, is:dados.password}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "confirmacaoSenha",
      "type": "password",
      "disabled": _vm.atualizacao
    },
    domProps: {
      "value": (_vm.confirmacaoSenha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmacaoSenha = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmacaoSenha')),
      expression: "errors.has('confirmacaoSenha')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmacaoSenha')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "a",
      "to": "/usuarios"
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "value": "Salvar"
    }
  })], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5edf600a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/usuarios/Form.vue
// module id = 167
// module chunks = 1